import { render, staticRenderFns } from "./DepartmentEditor.vue?vue&type=template&id=b2092b8a&"
import script from "./DepartmentEditor.vue?vue&type=script&lang=js&"
export * from "./DepartmentEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports